import { AllSizesResponse,SizesDropDownDto,SizesDropDownResponseModel,SizesResponse, itemSubCatIdreq } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { SizesRequest } from './dto/sizes-request';
import { SizesDto } from './dto/sizes-dto';
import { SizesService } from './sizes.service';
import { CategoryItemRequest } from './dto/category-item.request';
import { CommonResponse } from '@gtpl/shared-models/production-management';

@Controller('sizes')
@ApiTags('sizes')
export class SizesController {
    constructor(
        private sizeService: SizesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      @Post('/createSize')
     async createSize(@Body() sizedto:SizesDto,isUpdate:boolean=false,@Req() request:Request): Promise<SizesResponse> {
        try {
         return await this.sizeService.createSize(sizedto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(SizesResponse, error);
       }
     }

      
    @Post('/getAllSizes')
    async getAllSizes(): Promise<AllSizesResponse> {
        try {
            return await this.sizeService.getAllSizes();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllSizesResponse, error);
        }
    }

   @Post('/activateOrDeactivateSize')
   async activateOrDeactivateSize(@Body() sizeReq: SizesRequest): Promise<SizesResponse> {
       try {
           return await this.sizeService.activateOrDeactivateSize(sizeReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(SizesResponse, err);
       }
   }

    @Post('/updateSize')
    async updateSize(@Body() sizedto:SizesDto,isUpdate:boolean=true,@Req() request:Request): Promise<SizesResponse> {
        try {
         return await this.sizeService.createSize(sizedto,true,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(SizesResponse, error);
       }
     }

     @Post('/getAllSizesDropDown')
     async getAllSizesDropDown(): Promise<SizesDropDownResponseModel> {
         try {
         return await this.sizeService.getAllSizesDropDown();
         } catch (error) {
             return this.applicationExceptionHandler.returnException(SizesDropDownResponseModel, error)
         }
     }


     @Post('/getAllActiveSizesDropDown')
     async getAllActiveSizesDropDown(): Promise<SizesDropDownResponseModel> {
         try {
         return await this.sizeService.getAllActiveSizesDropDown();
         } catch (error) {
             return this.applicationExceptionHandler.returnException(SizesDropDownResponseModel, error)
         }
     }

     @Post('/getAllActiveSizesDropDownForCategory')
     async getAllActiveSizesDropDownForCategory(@Body() req:CategoryItemRequest): Promise<SizesDropDownResponseModel> {
         try {
         return await this.sizeService.getAllActiveSizesDropDownForCategory(req);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(SizesDropDownResponseModel, error)
         }
     }

     @Post('/getSizeById')
     async getSizeById(@Body() sizeReq: SizesRequest): Promise<SizesDropDownDto> {
         try {
             return await this.sizeService.getSizeDataById(sizeReq);
         } catch (err) {
             throw err;
         }
      }
      @Post('/getSizeByItemSubCategory')
      async getSizeByItemSubCategory(@Body() sizeReq: itemSubCatIdreq): Promise<CommonResponse> {
          try {
              return await this.sizeService.getSizeByItemSubCategory(sizeReq);
          } catch (err) {
              throw err;
          }
       }
}
